import { money } from "../../lib/format";
import type { StatisticsFilters } from "./types";

export function currencySymbol(currency: string) {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency, maximumFractionDigits: 0 }).format(0).replace(/\d/g, "").trim() || currency;
  } catch {
    return currency;
  }
}

export function formatCurrency(value: string | number, currency: string) {
  const amount = Number(value);
  if (Number.isFinite(amount) && amount < 0) return `-${currencySymbol(currency)}${money(Math.abs(amount))}`;
  return `${currencySymbol(currency)}${money(value)}`;
}

export function formatDate(value: string) {
  const date = new Date(value.length <= 10 ? `${value}T00:00:00` : value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}

export function formatPeriod(dateFrom: string, dateTo: string) {
  return `${formatDate(dateFrom)} – ${formatDate(dateTo)}`;
}

export function bucketLabel(value: string, bucket: StatisticsFilters["bucket"]) {
  if (bucket === "month" || value.length === 7) {
    const date = new Date(`${value}-01T00:00:00`);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString(undefined, date.getMonth() === 0 ? { month: "short", year: "numeric" } : { month: "short" });
  }
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function compactMoney(value: number) {
  return new Intl.NumberFormat(undefined, { notation: "compact", maximumFractionDigits: 1 }).format(value);
}

export function chartMoneyFormatter(currency: string) {
  return (value: number) => formatCurrency(value, currency);
}

export function truncateLabel(value: string) {
  return value.length > 18 ? `${value.slice(0, 17)}...` : value;
}
